import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationSmooth = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationSmooth',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4A68FB",
    d: "M63.94 78.54c-4.43.3-9.1.46-13.94.46-4.28 0-8.42-.12-12.38-.36-2.47 4.5-7.48 9.3-17.62 9.24V96h60v-7.26c-9.41.14-13.91-5.3-16.06-10.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9C72E6",
    d: "M63.94 78.54c-4.43.3-9.1.46-13.94.46-4.28 0-8.42-.12-12.38-.36-2.47 4.5-7.48 9.3-17.62 9.24V96h60v-7.26c-9.41.14-13.91-5.3-16.06-10.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8C66F1",
    d: "M63.94 78.54C62.2 74.59 62 71 62 71H40s-.22 3.71-2.38 7.64c3.96.24 8.1.36 12.38.36 4.84 0 9.51-.16 13.94-.46Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8C66F1",
    d: "M50 74c27.614 0 50-5.149 50-11.5S77.614 51 50 51 0 56.149 0 62.5 22.386 74 50 74Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70492)",
    d: "M50 72c27.614 0 50-5.149 50-11.5S77.614 49 50 49 0 54.149 0 60.5 22.386 72 50 72Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70492)",
    fillRule: "evenodd",
    d: "M72.9 64c7.71-.72 14.25-1.78 18.97-3.08-.41-7.69-2-27.78-7.77-36.57C76 12 65 14 61 25c-4.17 11.47-3 39-3 39h14.9Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70492)",
    fillRule: "evenodd",
    d: "M27.1 64h14.78s1.17-27.53-3-39c-4-11-15-13-23.1-.65-5.76 8.78-7.36 28.82-7.77 36.53 4.74 1.32 11.32 2.4 19.09 3.12Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70492)",
    fillRule: "evenodd",
    d: "M65.86 64s.93-29.58-4-41.45C57 10.86 44 9.8 38 21.49 31.71 33.75 31.86 64 31.86 64h34Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_21134_70492)",
    fillRule: "evenodd",
    d: "M50 65c.66 0 1.32 0 1.98-.01.08-6.13.04-24.77-3.33-33.1-4-9.9-14.68-10.8-19.61-.9-4.03 8.09-4.84 25.44-5 32.7C31.61 64.52 40.49 65 50 65Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_21134_70492)",
    fillRule: "evenodd",
    d: "M46.17 64.97a242.604 242.604 0 0 0 6.8.01c.3 0 .59-.01.88-.01.71-.01 1.41-.02 2.11-.04.31-.01.61-.01.92-.02.75-.02 1.5-.04 2.24-.07.21-.01.42-.01.63-.02.98-.03 1.95-.07 2.9-.12h.06c.92-.04 1.83-.09 2.73-.15l.55-.03 2.28-.15c.17-.01.34-.02.5-.04 1.84-.13 3.63-.29 5.36-.46.06-7.03-.16-24.11-3.34-31.99-4-9.9-14.68-10.8-19.61-.9-4.27 8.64-4.91 27.75-5.01 33.99Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70492",
    x1: 51.103,
    x2: 49.278,
    y1: 86.415,
    y2: 43.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#AB95EC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.18,
    stopColor: "#A78CEB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.656,
    stopColor: "#9F79E8"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.987,
    stopColor: "#9C72E7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70492",
    x1: 51.602,
    x2: 92.213,
    y1: 40.701,
    y2: 39.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.16,
    stopColor: "#ED357A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.174,
    stopColor: "#EE3D74"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.275,
    stopColor: "#F1754C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.368,
    stopColor: "#F4A12C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.451,
    stopColor: "#F6C015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.522,
    stopColor: "#F8D307"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.57,
    stopColor: "#F8DA02"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.67,
    stopColor: "#F8D704"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.738,
    stopColor: "#F7CE0A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.796,
    stopColor: "#F6BF16"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.848,
    stopColor: "#F5AA25"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.897,
    stopColor: "#F38E39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.943,
    stopColor: "#F16C52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.985,
    stopColor: "#EE446F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#ED357A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70492",
    x1: -0.805,
    x2: 41.083,
    y1: 38.787,
    y2: 40.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.181,
    stopColor: "#ED357A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.195,
    stopColor: "#EE3D74"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.29,
    stopColor: "#F1754C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.379,
    stopColor: "#F4A12C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.458,
    stopColor: "#F6C015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.524,
    stopColor: "#F8D307"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.57,
    stopColor: "#F8DA02"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.67,
    stopColor: "#F8D704"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.738,
    stopColor: "#F7CE0A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.796,
    stopColor: "#F6BF16"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.848,
    stopColor: "#F5AA25"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.897,
    stopColor: "#F38E39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.943,
    stopColor: "#F16C52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.985,
    stopColor: "#EE446F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#ED357A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70492",
    x1: 28.191,
    x2: 67.315,
    y1: 38.938,
    y2: 38.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.181,
    stopColor: "#ED357A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.195,
    stopColor: "#EE3D74"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.29,
    stopColor: "#F1754C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.379,
    stopColor: "#F4A12C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.458,
    stopColor: "#F6C015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.524,
    stopColor: "#F8D307"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.57,
    stopColor: "#F8DA02"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.67,
    stopColor: "#F8D704"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.738,
    stopColor: "#F7CE0A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.796,
    stopColor: "#F6BF16"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.848,
    stopColor: "#F5AA25"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.897,
    stopColor: "#F38E39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.943,
    stopColor: "#F16C52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.985,
    stopColor: "#EE446F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#ED357A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_21134_70492",
    x1: 20.479,
    x2: 54.925,
    y1: 44.5,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ED357A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.231,
    stopColor: "#F2863F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.422,
    stopColor: "#F6C213"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.513,
    stopColor: "#F8DA02"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.626,
    stopColor: "#F8D704"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.703,
    stopColor: "#F7CE0A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.768,
    stopColor: "#F6BF16"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.828,
    stopColor: "#F5AA25"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.883,
    stopColor: "#F38E39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.935,
    stopColor: "#F16C52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.984,
    stopColor: "#EE446F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#ED357A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_21134_70492",
    x1: 42.888,
    x2: 77.331,
    y1: 44.808,
    y2: 44.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ED357A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.017,
    stopColor: "#EE3D74"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.141,
    stopColor: "#F1754C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.256,
    stopColor: "#F4A12C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.358,
    stopColor: "#F6C015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.444,
    stopColor: "#F8D307"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.504,
    stopColor: "#F8DA02"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.617,
    stopColor: "#F8D704"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.693,
    stopColor: "#F7CE0A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.757,
    stopColor: "#F6BF16"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.816,
    stopColor: "#F5AA25"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.871,
    stopColor: "#F38E39"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.922,
    stopColor: "#F16C52"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.971,
    stopColor: "#EE446F"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.987,
    stopColor: "#ED357A"
  }))));
};
ColoredIllustrationSmooth.displayName = 'ColoredIllustrationSmooth';
export default withProvisionalOverrideFromContext(ColoredIllustrationSmooth);
//# sourceMappingURL=index.js.map